import React, { useState } from "react";
import CCrud from "../../components/molecules/crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { IoIosAdd } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Box, Text, VStack } from "@chakra-ui/react";
import {
  createSpecialtyRequest,
  deleteSpecialtyRequest,
  getSpecialtiesRequest,
  updateSpecialtyRequest,
} from "../../services/modules/specialty/specialty";
import AddMoreNames from "../../components/addMoreNames";
import { toast } from "react-toastify";

const Specialties = ({ deleteFun, paginationPage }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const type = searchParams.get("type");
  const list = useSelector((state) => state.specialties.specialties);
  const count = useSelector((state) => state.specialties.count);
  const load = useSelector((state) => state.specialties.load);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [page, setPage] = useState(1);
  const [subSpecialtiesNames, setSubspecialtiesNames] = useState([]);

  const [filterObj, setFilterObj] = useState(null);

  const handlePageChange = (page) => {
    setPage(page);
    setFilterObj((prev) => {
      return { ...prev, page_number: page };
    });
  };

  const getList = async (filterObj) => {
    const requestData = {
      params: {
        page_size: 10,
        page_number: 1,
        keyword: "",
        sort_by: "id",
        ...filterObj,
      },
    };
    dispatch(getSpecialtiesRequest(requestData));
  };

  const rowData = (data) => {
    setSelectedRow(data);
  };
  const handelSubmit = (data, formik) => {
    // const { name, nameAr, isFulfillmentCenter, fulfillmentCenter, fees } = data;
    const action = () => {
      searchParams.delete("id");
      searchParams.delete("type");
      navigate("/specialties");
      !id && formik?.resetForm();
      toast.success(
        ` ${id ? "specialty" : "New specialty"} has been ${
          id ? "updated" : "created"
        } successfully`
      );
    };
    const requestData = {
      body: {
        ...data,
        sub_specialties: subSpecialtiesNames,
      },
      id: id,
      action,
    };
    if (id) {
      //update call
      delete requestData?.body?.Actions;
      dispatch(updateSpecialtyRequest(requestData));
    } else {
      //create call
      dispatch(createSpecialtyRequest(requestData));
    }
  };

  //list of actions to be displayed when clicked in the 3 dots
  const actionsList = ({ index, data }) => {
    return [
      {
        condition: () => {
          return true;
        },
        click: () => {
          navigate(`?type=form&id=${data?.id}`);
        },
        text: "Edit",
      },
      {
        condition: () => {
          return true;
        },
        click: () => {
          dispatch(
            deleteSpecialtyRequest({
              id: data?.id,
            })
          );
        },
        text: "Delete",
      },
    ];
  };

  //if you need more buttons in the header beside the add button
  const headerChildren = <></>;

  //if more modals needed, pass them to the modalComponents as below
  const modalComponents = [];

  // listing all cities
  useEffect(() => {
    getList();
  }, []);

  const detailsTemplateData = {
    pageTitle: "City Details",
    data: {
      list: [],
    },
  };
  const formChildren = (
    <VStack p={3} w="70%" gap={2} alignItems="start">
      <Text
        as="span"
        sx={{
          color: "#797979",
          fontSize: "18px",
          fontFamily: "Jost",
        }}
      >
        Sub specialties Names
      </Text>
      <AddMoreNames
        setData={setSubspecialtiesNames}
        data={subSpecialtiesNames}
      />
    </VStack>
  );
  return (
    <Box w="100%">
      <CCrud
        table={{
          list: list,
          listTitle: "Specialties",
          createBtnTitle: "New Specialty",
          CreateBtnIcon: IoIosAdd,
          createBtnFun: () => navigate("?type=form"),
          columns: [
            { accessor: "id", Header: "#" },
            {
              accessor: "name",
              Header: "Specialties name",
              sort: false,
            },
            {
              accessor: "name_ar",
              Header: "Specialties Arabic name",
              sort: false,
            },

            { accessor: "Actions", Header: "Actions" },
          ],
          isSearch: false,
          searchInputPlaceholder: "Search by Specialties name",
          isChecked: false,
          total_count: count,
          isSort: true,
          setFilterObj,
          className: "organization-table system-configurations-table",
          paginationPage: paginationPage,
          handlePageChange,
          rowData: rowData,
          className: "main-table",
          actionsList, //if you want to add custom actions list
          headerChildren,
          openDeleteModal,
          setOpenDeleteModal,
          // handleDeleteRequest,
        }}
        form={{
          initialValues: !id ? {} : initialValues(selectedRow?.rowData),
          structure: () => structure(),
          validationSchema: validationSchema,
          deleteFun: deleteFun,
          title: id ? "Edit Specialties" : "Add Specialties",
          submitTitle: id ? "Update" : "Add",
          onSubmit: handelSubmit,
          className: { form: "main-form", actionButton: "main-form-buttons" },
          formChildren,
        }}
        // DetailsComponent={<Details />} //to send details component diff from the default
        modalComponents={modalComponents}
      />
    </Box>
  );
};

export default Specialties;
